<ol class="em-c-breadcrumbs" role="navigation">
  <li class="em-c-breadcrumbs__item" *ngFor="let item of items">
    <a [routerLink]="[item.link]" class="em-c-breadcrumbs__link">{{
      item.text
    }}</a>
  </li>
</ol>
